import React from 'react';
import { SmartphoneIcon, RouterIcon, ChevronRightIcon, ZapIcon } from 'lucide-react';
const devices = [{
  name: 'HD WebRTC IP Deskphone',
  brand: 'Office Bridge',
  price: 199,
  monthly: 8,
  image: 'https://images.unsplash.com/photo-1544197150-b99a580bb7a8?auto=format&fit=crop&q=80&w=400',
  tag: 'Effy Hardware'
}, {
  name: 'AI Smart Intrusion Camera',
  brand: 'AI Security',
  price: 249,
  monthly: 10,
  image: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?auto=format&fit=crop&q=80&w=400',
  tag: 'Effy Vision'
}, {
  name: 'Smart IP Access Control Panel',
  brand: 'Access Control',
  price: 349,
  monthly: 14,
  image: 'https://images.unsplash.com/photo-1558346490-a72e53ae2d4f?auto=format&fit=crop&q=80&w=400',
  tag: 'Effy Pass'
}];
export function DeviceMarketplace() {
  return <section id="marketplace" className="py-20 bg-white dark:bg-black transition-colors duration-300 relative border-t border-gray-200 dark:border-white/10" data-id="element-108" data-mp="2xyqtqilolts2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109" data-mp="2mkljkrfp0zgy">
        <div className="text-center mb-12" data-id="element-110" data-mp="2ihyo8gjtcwf0">
          <div className="inline-block bg-black dark:bg-white text-white dark:text-black font-black uppercase tracking-widest text-[10px] px-4 py-1.5 rounded-full mb-6 border-2 border-black dark:border-white" data-id="element-111" data-mp="2ij9rmf9ck25l">
            PRE-CONFIGURED BUSINESS HARDWARE
          </div>
        </div>
        <div className="flex flex-col md:flex-row justify-between items-end mb-12 gap-8 border-b-4 border-[#13E200] pb-6" data-id="element-112" data-mp="23tawymh038uv">
          <div data-id="element-113" data-mp="1urbedpqc7wpt">
            <h2 className="text-4xl font-black tracking-tighter text-black dark:text-white uppercase italic transition-colors duration-300" data-id="element-114" data-mp="1uqt8e1dvi44p">
              Shop Devices & <span className="text-[#13E200]" data-id="element-115" data-mp="1pu2wlq93pup3">Hardware</span>
            </h2>
            <p className="text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest text-xs mt-2 transition-colors duration-300" data-id="element-116" data-mp="3p41ame46hi0d">
              Get the latest enterprise tech pre-configured with Effy Business eSIMs and security setups.
            </p>
          </div>
          <button className="flex items-center gap-2 text-black dark:text-white font-bold uppercase tracking-widest text-xs hover:text-[#13E200] dark:hover:text-[#13E200] transition-colors group" data-id="element-117" data-mp="bwgkbct5fu0g">
            See All Hardware{' '}
            <ChevronRightIcon className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-118" data-mp="34ero0pbni0q" />
          </button>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-119" data-mp="uv2o4zg1vz82">
          {devices.map((device, i) => <div key={i} className="bg-white dark:bg-[#0E131F] rounded-3xl border-2 border-gray-200 dark:border-white/10 hover:border-[#13E200] dark:hover:border-white transition-all group shadow-sm hover:shadow-xl flex flex-col relative overflow-hidden" data-id="element-120" data-mp="usq8wu1og2yp" data-mpi={i}>
              <div className="absolute top-4 left-4 bg-[#13E200] text-black border-2 border-black text-[8px] font-black uppercase tracking-widest px-2 py-1 rounded shadow-sm z-10" data-id="element-121" data-mp="31kr2vz8bchmc">
                Add to Plan at Checkout
              </div>
              <div className="aspect-[4/3] relative overflow-hidden bg-gray-50 dark:bg-black/50 p-8 flex items-center justify-center transition-colors duration-300" data-id="element-122" data-mp="2z2xexz5wcrg7">
                <img src={device.image} alt={device.name} className="max-h-full object-contain group-hover:scale-105 transition-all duration-500" data-id="element-123" data-mp="381921r7k173w" />
                <div className="absolute top-4 left-4" data-id="element-124" data-mp="2fb0t8pywrz1z">
                  <span className="px-3 py-1 bg-black dark:bg-white text-white dark:text-black text-[10px] font-black uppercase tracking-widest rounded-full transition-colors duration-300" data-id="element-125" data-mp="2bcjjrzs0mche">
                    {device.tag}
                  </span>
                </div>
              </div>

              <div className="p-6" data-id="element-126" data-mp="1wlu5upn66j9u">
                <div className="mb-4" data-id="element-127" data-mp="1wkst8gqi9oq0">
                  <p className="text-[10px] font-black text-[#13E200] uppercase tracking-widest mb-1" data-id="element-128" data-mp="1rnsme3lu0hxu">
                    {device.brand}
                  </p>
                  <h3 className="text-xl font-black text-black dark:text-white tracking-tighter transition-colors duration-300" data-id="element-129" data-mp="25c2sjk6oogod">
                    {device.name}
                  </h3>
                </div>

                <div className="space-y-2 mb-6" data-id="element-130" data-mp="2f6ck4znsxay1">
                  <div className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-white/10 transition-colors duration-300" data-id="element-131" data-mp="2jze1debhdmks">
                    <span className="text-xs text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest transition-colors duration-300" data-id="element-132" data-mp="2o2tw253zpcuu">
                      Retail Price
                    </span>
                    <span className="text-sm font-black text-black dark:text-white transition-colors duration-300" data-id="element-133" data-mp="2xx2pqw4rbbul">
                      ${device.price}
                    </span>
                  </div>
                  <div className="flex justify-between items-center py-2" data-id="element-134" data-mp="18jz5yeyx72rs">
                    <span className="text-xs text-gray-500 dark:text-gray-400 font-bold uppercase tracking-widest transition-colors duration-300" data-id="element-135" data-mp="18k8urz88b3vw">
                      As low as
                    </span>
                    <span className="text-lg font-black text-[#13E200]" data-id="element-136" data-mp="3h1fm33uh2lid">
                      ${device.monthly}
                      <span className="text-[10px] text-gray-400 dark:text-gray-500 transition-colors duration-300" data-id="element-137" data-mp="382u5he8k9gk8">/mo</span>
                    </span>
                  </div>
                </div>

                <button className="w-full cricket-btn-primary" data-id="element-138" data-mp="8ldyxeum30yk">Shop Now</button>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}